/**
 * FNV-1a hash folded into a fraction in [0, 1).
 *
 * Deterministic and dependency free, so the exact same value can be computed
 * by the generator scripts (when writing `rd.json`) and by the front-end (when
 * resolving blip collisions). Replacing `Math.random()` with this is what makes
 * blip positions stable between two page loads.
 */
export const hashFraction = (seed: string): number => {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return ((h >>> 0) % 100000) / 100000;
};
